import React from 'react';
import { defaultCloseButton, initModal } from '../../components/modal';
import { CardNumberEntry } from './card-number-entry';
import styled from 'styled-components';
import { DeviceType, PlayerCardOperator } from '../../types';
import { KioskCaesarsInstructions, PosCaesarsInstructions } from './czr-instructions';
import { KioskWilliamHillInstructions, PosWilliamHillInstructions } from './wh-instructions';
import { Heading, Text } from '../../components/typography';

export function showSearchCard({
  deviceType,
  playerCardOperator
}: {
  deviceType: DeviceType;
  playerCardOperator: PlayerCardOperator;
}) {
  if (playerCardOperator === 'NONE') {
    initModal({
      open: true,
      title: 'Bet unavailable',
      content: deviceType === 'POS' ? <PosBetUnavailableContent /> : <KioskBetUnavailableContent />,
      actions: [defaultCloseButton]
    });
    return;
  }

  initModal({
    actions: [],
    open: true,
    title: 'Bet Exclusively Available to Rewards Card Holders - Activate your Card',
    content: (
      <>
        <Instructions {...{ deviceType, playerCardOperator }} />
        <Line />
        <CardNumberEntry {...{ playerCardOperator }} />
      </>
    ),
    width: 'large'
  });
}

function Instructions({
  deviceType,
  playerCardOperator
}: {
  deviceType: DeviceType;
  playerCardOperator: PlayerCardOperator;
}) {
  if (deviceType === 'KIOSK' && playerCardOperator === 'CAESARS') {
    return <KioskCaesarsInstructions />;
  } else if (deviceType === 'POS' && playerCardOperator === 'CAESARS') {
    return <PosCaesarsInstructions />;
  } else if (deviceType === 'KIOSK') {
    return <KioskWilliamHillInstructions />;
  } else {
    return <PosWilliamHillInstructions />;
  }
}

const PosBetUnavailableContent = () => (
  <>
    <Heading>This bet is unavailable to non rewards customers</Heading>
    <Text>Make another selection</Text>
  </>
);

const KioskBetUnavailableContent = () => (
  <>
    <Heading>Bet is unavailable in this venue</Heading>
    <Text>Make another selection</Text>
  </>
);

const Line = styled.div`
  flex: 1;
  border-bottom: 1px solid #dadada;
`;

export const forTestOnly = { PosBetUnavailableContent, KioskBetUnavailableContent };
